import { render, staticRenderFns } from "./PurchaseTab.vue?vue&type=template&id=1f9a8388&scoped=true"
import script from "./PurchaseTab.vue?vue&type=script&lang=js"
export * from "./PurchaseTab.vue?vue&type=script&lang=js"
import style0 from "./PurchaseTab.vue?vue&type=style&index=0&id=1f9a8388&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9a8388",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f9a8388')) {
      api.createRecord('1f9a8388', component.options)
    } else {
      api.reload('1f9a8388', component.options)
    }
    module.hot.accept("./PurchaseTab.vue?vue&type=template&id=1f9a8388&scoped=true", function () {
      api.rerender('1f9a8388', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cashier/PurchaseTab.vue"
export default component.exports